import { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getIsSaving, getLastSavedPpiId } from '../selectors';
import { createPpi as createPpiAction } from '../actions';

const useCreatePpi = () => {
  const [hasSaved, setHasSaved] = useState(false);
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const createdPpiId = useSelector(getLastSavedPpiId);

  const createPpi = (data, callback) => {
    console.log('Create PPI');

    const itemCode = _.get(data, 'referencedIngredientData.itemCode');
    const hash = _.get(data, 'referencedIngredientData.modifyDate');
    const ppi = _.omit(data, ['referencedIngredientData']);
    ppi.hash = hash;
    console.log('  -- ingredient', itemCode, hash);
    console.log('  -- ppi', ppi);

    dispatch(createPpiAction(itemCode, ppi, callback));
    setHasSaved(true);
  };

  return [createPpi, isSaving, hasSaved ? createdPpiId : null];
};

export default useCreatePpi;
